import * as React from 'react';
import * as ReactDOM from 'react-dom';

export interface GridColumnProps extends kendo.ui.GridColumn { }

let GridColumn: React.StatelessComponent<GridColumnProps> = (props: GridColumnProps): JSX.Element | null => null;

GridColumn.displayName = 'GridColumn';

export default GridColumn;


// WEBPACK FOOTER //
// ./packages/kendo-grid-react-wrapper/src/grid/GridColumn.tsx